"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ApiProvider = require("./ApiProvider");
Object.keys(_ApiProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ApiProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ApiProvider[key];
    }
  });
});
var _Details = require("./Details");
Object.keys(_Details).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Details[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Details[key];
    }
  });
});
var _Widget = require("./Widget");
Object.keys(_Widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Widget[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Widget[key];
    }
  });
});
var _WidgetSkeletonWrapper = require("./WidgetSkeletonWrapper");
Object.keys(_WidgetSkeletonWrapper).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WidgetSkeletonWrapper[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WidgetSkeletonWrapper[key];
    }
  });
});
